import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["item", "button"]
  static values = {
    limit: { type: Number, default: 16 },
    storageKey: String
  }

  connect() {
    this.limitValue = this.limitValue || 16
    this.restoreVisibleCount()
    this.applyInitialVisibility()
    this.updateButtonVisibility()
  }

  showMore(event) {
    event?.preventDefault()
    const start = this.visibleCount
    const end = Math.min(this.visibleCount + this.limitValue, this.itemTargets.length)

    for (let index = start; index < end; index += 1) {
      const item = this.itemTargets[index]
      if (item) item.classList.remove("hidden")
    }

    this.visibleCount = end
    this.persistVisibleCount()
    this.updateButtonVisibility()
  }

  applyInitialVisibility() {
    if (!this.hasItemTarget) return

    this.itemTargets.forEach((item, index) => {
      if (index < this.visibleCount) {
        item.classList.remove("hidden")
      } else {
        item.classList.add("hidden")
      }
    })
  }

  updateButtonVisibility() {
    if (!this.hasButtonTarget) return

    if (this.visibleCount >= this.itemTargets.length) {
      this.buttonTarget.textContent = "No more parts"
      this.buttonTarget.disabled = true
      this.buttonTarget.classList.add("cursor-not-allowed", "opacity-70")
    } else {
      this.buttonTarget.textContent = "Load more parts"
      this.buttonTarget.disabled = false
      this.buttonTarget.classList.remove("cursor-not-allowed", "opacity-70")
      this.buttonTarget.classList.remove("hidden")
    }
  }

  restoreVisibleCount() {
    const stored = this.storageKeyValue ? window.sessionStorage.getItem(this.storageKeyValue) : null
    const parsed = stored ? parseInt(stored, 10) : NaN
    let initialVisible = Math.min(this.limitValue, this.itemTargets.length)

    if (!Number.isNaN(parsed) && parsed > 0) {
      initialVisible = Math.min(parsed, this.itemTargets.length)
    }

    this.visibleCount = initialVisible
  }

  persistVisibleCount() {
    if (!this.storageKeyValue) return
    try {
      window.sessionStorage.setItem(this.storageKeyValue, String(this.visibleCount))
    } catch (error) {
      // Ignore storage errors (e.g., private mode)
    }
  }
}
